import { render, staticRenderFns } from "./EducationLevelComponent.vue?vue&type=template&id=6dc1df4b"
import script from "./EducationLevelComponent.vue?vue&type=script&lang=js"
export * from "./EducationLevelComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports